var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpsellStatusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6198 6.68017C20.0368 6.98143 20.1242 7.55512 19.8151 7.96155L12.3644 17.7588C11.7456 18.5725 10.5667 18.7424 9.73272 18.138L4.37909 14.258C3.96257 13.9561 3.87599 13.3823 4.18571 12.9763C4.49544 12.5703 5.08418 12.4859 5.50071 12.7878L10.8543 16.6678L18.3051 6.87061C18.6141 6.46418 19.2028 6.37892 19.6198 6.68017Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpsellStatusIcon);
export default __webpack_public_path__ + "static/media/upsell-status-icon.c4649960fb6d387c1dcfeef5512ec37f.svg";
export { ForwardRef as ReactComponent };